/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryVariablesGQLType = Types.Exact<{
  receiptId: Types.Scalars['UUID'];
  type: Types.InputTypeGQLType;
}>;


export type GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<Types.QueryGQLType, 'deliverablesContainerReceiptZipFilesDownloadUrl'>
);


export const GetDeliverablesContainerReceiptZipFilesDownloadUrlDocumentGQLType = gql`
    query GetDeliverablesContainerReceiptZipFilesDownloadUrl($receiptId: UUID!, $type: InputType!) {
  deliverablesContainerReceiptZipFilesDownloadUrl(
    receiptId: $receiptId
    type: $type
  )
}
    `;

/**
 * __useGetDeliverablesContainerReceiptZipFilesDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetDeliverablesContainerReceiptZipFilesDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverablesContainerReceiptZipFilesDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverablesContainerReceiptZipFilesDownloadUrlQuery({
 *   variables: {
 *      receiptId: // value for 'receiptId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDeliverablesContainerReceiptZipFilesDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryGQLType, GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryGQLType, GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryVariablesGQLType>(GetDeliverablesContainerReceiptZipFilesDownloadUrlDocumentGQLType, options);
      }
export function useGetDeliverablesContainerReceiptZipFilesDownloadUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryGQLType, GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryGQLType, GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryVariablesGQLType>(GetDeliverablesContainerReceiptZipFilesDownloadUrlDocumentGQLType, options);
        }
export type GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryHookResult = ReturnType<typeof useGetDeliverablesContainerReceiptZipFilesDownloadUrlQuery>;
export type GetDeliverablesContainerReceiptZipFilesDownloadUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverablesContainerReceiptZipFilesDownloadUrlLazyQueryGQLType>;
export type GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryResultGQLType = Apollo.QueryResult<GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryGQLType, GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryVariablesGQLType>;